export default __webpack_public_path__ + "static/media/89.7a60ca10.jpg";